import React, { useState, useEffect, useContext } from "react";
import Moment from "moment";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";

import { AuthContext } from "../contexts/AuthContext";
import { ScreenContext } from "../contexts/ScreenContext";
import { ClientContext } from "../contexts/ClientContext";
import { HoursContext } from "../contexts/HoursContext";

import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";

import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Select from "@material-ui/core/Select";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import Switch from "@material-ui/core/Switch";

import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";

import green from "@material-ui/core/colors/green";
import orange from "@material-ui/core/colors/orange";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  fieldSpacing: {
    marginBottom: 0,
  },
  formControl: {
    margin: theme.spacing(1),
    flexGrow: 1,
  },
  rnd: {
    marginTop: theme.spacing(1),
    flexGrow: 1,
  },
  formAction: {
    marginRight: theme.spacing(1),
  },
  newForm: {
    color: "white",
    backgroundColor: green[500],
    fontSize: "12px",
    fontWeight: 900,
    marginTop: "1px",
    marginRight: theme.spacing(1),
  },
  updateForm: {
    color: "white",
    backgroundColor: orange[500],
    fontSize: "12px",
    fontWeight: 900,
    marginTop: "1px",
    marginRight: theme.spacing(1),
  },
  "@keyframes highlighter": {
    from: { backgroundColor: "yellow" },
    to: { backgroundColor: "white" },
  },
  highlight: {
    animationName: "$highlighter",
    animationDuration: "1s",
    animationTimingFunction: "linear",
    animationIterationCount: 1,
    backgroundColor: "yellow",
  },
}));

const ManageHours = (props) => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const { screenSize, setSnackbarMessage } = useContext(ScreenContext);
  const { clients, selectedClient, setSelectedClient } =
    useContext(ClientContext);
  const { date, jobDetails, setJobDetails, saveHour } =
    useContext(HoursContext);

  const { setShowForm, formAction, setFormAction } = props;

  const [completed, setCompleted] = useState(Moment(date).format("YYYY-MM-DD"));
  const [jobType, setjobType] = useState("Direct");
  const [jobCategory, setjobCategory] = useState("Service");
  const [startTime, setStartTime] = useState("08:00");
  const [endTime, setEndTime] = useState("08:00");
  const [travelTime, setTravelTime] = useState("0.00");
  const [hourDuration, setHourDuration] = useState(0.0);
  const [description, setDescription] = useState("");
  const [RnD, setRnD] = useState(false);
  const [platform, setPlatform] = useState("");
  const [highlight, setHighlight] = useState(false);
  const [dateHighlight, setDateHighlight] = useState(false);

  const [combinedID, setCombinedID] = useState("");

  const handleClientChange = (value) => {
    setSelectedClient([value]);
  };

  const handleTravelTime = (event) => {
    setTravelTime(event.target.value);
  };

  const handleStartTimeOnChange = (event) => {
    setStartTime(event.target.value);
  };

  const handleEndTimeOnChange = (event) => {
    setEndTime(event.target.value);
  };

  const handleStartTimeOnBlur = (event) => {
    const cDate = Moment(completed).format("YYYY-MM-DD");
    const start = Moment(`${cDate} ${event.target.value}`);
    const remainder = 15 - (start.minute() % 15);
    let dateTime = "";

    if (remainder > 7) {
      dateTime = Moment(start)
        .subtract(15 - remainder, "minutes")
        .format("HH:mm:ss");
    } else {
      dateTime = Moment(start).add(remainder, "minutes").format("HH:mm:ss");
    }

    // alert(dateTime);
    setStartTime(dateTime);
  };

  const handleEndTimeOnBlur = (event) => {
    const cDate = Moment(completed).format("YYYY-MM-DD");
    const end = Moment(`${cDate} ${event.target.value}`);
    // alert(cDate);
    const remainder = 15 - (end.minute() % 15);
    let dateTime = "";

    if (remainder > 7) {
      dateTime = Moment(end).subtract(15 - remainder, "minutes");
    } else {
      dateTime = Moment(end).add(remainder, "minutes");
    }

    const start = Moment(`${cDate} ${startTime}`);
    const duration = Moment.duration(dateTime.diff(start));

    if (duration.asHours() < 0.25) {
      dateTime = Moment(end).add(15, "minutes");
    }

    setEndTime(dateTime.format("HH:mm:ss"));
  };

  const handleJobTypeChange = (event, type) => {
    if (type) setjobType(type);
  };

  const handleJobCategoryChange = (event, category) => {
    if (category) setjobCategory(category);
  };

  const handleRnD = (event) => {
    setRnD(event.target.checked);
  };

  const handlePlatform = (event) => {
    setPlatform(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const resetForm = () => {
    setJobDetails({ key: Math.random() }); // { key: Math.random() } forces JobDetails state to refresh
    setSelectedClient(null);
    setCombinedID("");
    setHighlight(false);
    setFormAction("New");

    if (screenSize === "lg" || screenSize === "xl") {
      setShowForm(true);
    } else {
      setShowForm(false);
    }
  };

  const handleCancel = () => {
    resetForm();
  };

  const handleSave = () => {
    let error = [];

    if (!selectedClient || !selectedClient[0]) {
      error.push("Client is required!");
    }

    if (description.trim() == "") {
      error.push("Description is required!");
    }

    if (error.length > 0) {
      let message = error.join("\n");

      setSnackbarMessage({
        message,
        severity: "error",
      });

      return;
    }


    let selectedDate = Moment(date).format("YYYY-MM-DD");




    let form = {
      FormAction: formAction,
      CombinedID: combinedID,
      Completed: selectedDate,
      Who: user.username,
      ID: selectedClient && selectedClient[0] ? selectedClient[0].ID : null,
      TravelTime: travelTime,
      StartTime: Moment(`${selectedDate} ${startTime}`).format("HH:mm:ss"),
      EndTime: Moment(`${selectedDate} ${endTime}`).format("HH:mm:ss"),
      Qty: hourDuration,
      Category: jobCategory,
      Type: jobType,
      isRND: RnD ? 1 : 0,
      Platform: platform,
      Description: description ? description.split("\n").join("<br>") : "",
    };


    saveHour(form);
    // resetForm();
  };

  useEffect(() => {
    // Convert `startsAt` and `endsAt` strings to moment date objects

    if (startTime != "" && endTime != "") {
      const selectdate = Moment(completed).format("YYYY-MM-DD");
      const start = Moment(`${selectdate} ${startTime}`);
      const end = Moment(`${selectdate} ${endTime}`);

      if (start > end) {
        setEndTime(startTime);
        return;
      }

      const duration = Moment.duration(end.diff(start));
      const c = duration.asHours();
      setHourDuration(c.toFixed(2));


    }
  }, [startTime, endTime]);

  useEffect(() => {
    if (jobDetails && formAction === "Update") {
      setHighlight(true);
      setStartTime(jobDetails.StartTime);
      setEndTime(jobDetails.EndTime);
      setTravelTime(jobDetails.TravelTime ? jobDetails.TravelTime : "0.00");
      setjobType(jobDetails.DorI);
      setjobCategory(jobDetails.Category);
      setDescription(
        jobDetails.Description
          ? jobDetails.Description.split("<br>").join("\n")
          : ""
      );
      setRnD(jobDetails.isRND == 1 ? true : false);
      setPlatform(jobDetails.Platform ? jobDetails.Platform : "");
      setCompleted(Moment(jobDetails.Completed).format("YYYY-MM-DD"));
      setCombinedID(
        `${selectedClient[0].ID}|${Moment(jobDetails.Completed).format(
          "YYYY-MM-DD"
        )}|${jobDetails.StartTime}|${user.username}`
      );
      setTimeout(() => {
        setHighlight(false);
      }, 1000);
    } else {
      setFormAction("New");
      setStartTime("08:00");
      setEndTime("08:00");
      setTravelTime("0.00");
      setjobType("Direct");
      setjobCategory("Service");
      setDescription("");
      setRnD(false);
      setPlatform("");
      setCombinedID("");
      setCompleted(Moment(date).format("YYYY-MM-DD"));
      setSelectedClient(null);
    }
  }, [jobDetails]);

  useEffect(() => {

    setDateHighlight(true);
    setTimeout(() => {
      setDateHighlight(false);
    }, 1000);
  }, [date]);

  return (
    <form>
      <Card elevation={0} variant="outlined">
        <CardContent style={{ paddingRight: 30 }}>
          <Grid
            container
            justifyContent="flex-start"
            className={classes.formControl}
          >
            <Typography
              variant="overline"
              align="left"
              className={classes.formAction}
            >
              Form Action:
            </Typography>
            <Chip
              size="small"
              className={
                formAction == "New" ? classes.newForm : classes.updateForm
              }
              label={formAction.toUpperCase()}
            />
            {combinedID && (
              <Grid item md={"auto"} sm={12}>
                <Typography
                  variant="overline"
                  align="left"
                  className={classes.formAction}
                >
                  Combined ID:
                </Typography>
                <Typography
                  variant="overline"
                  align="left"
                  className={classes.formAction}
                  style={{ fontWeight: 900 }}
                >
                  {combinedID}
                </Typography>
              </Grid>
            )}
          </Grid>

          <Grid container spacing={2}>
            <Grid item md={6} xs={6}>
              <TextField
                id="hours-date"
                name="date"
                label="Date"
                variant="outlined"
                className={
                  highlight || dateHighlight
                    ? clsx(classes.formControl, classes.highlight)
                    : classes.formControl
                }
                fullWidth={true}
                InputProps={{ readOnly: true }}
                value={Moment(date).format("MM-DD-YYYY")}
              />
            </Grid>
            <Grid item md={6} xs={6}>
              <TextField
                id="hours-who"
                name="who"
                label="Who"
                variant="outlined"
                className={
                  highlight
                    ? clsx(classes.formControl, classes.highlight)
                    : classes.formControl
                }
                fullWidth={true}
                InputProps={{ readOnly: true }}
                value={user.username}
              />
            </Grid>
          </Grid>

          <Autocomplete
            id="hours-client-autocomplete"
            className={
              highlight
                ? clsx(classes.formControl, classes.highlight)
                : classes.formControl
            }
            fullWidth={true}
            options={clients}
            value={selectedClient ? selectedClient[0] : null}
            getOptionLabel={(client) => `${client.ID} | ${client.Name}`}
            getOptionSelected={(option, value) => option.ID === value.ID}
            renderInput={(params) => (
              <TextField
                required
                {...params}
                id="hours-client"
                name="client"
                label="Client"
                variant="outlined"
              />
            )}
            onChange={(e, value) => {
              handleClientChange(value);
            }}
          />

          <Grid container spacing={2} className={classes.fieldSpacing}>
            <Grid item md={4} xs={12}>
              <FormControl
                variant="outlined"
                className={
                  highlight
                    ? clsx(classes.formControl, classes.highlight)
                    : classes.formControl
                }
                fullWidth={true}
              >
                <InputLabel id="hours-travel-time-label" variant="outlined">Travel Time</InputLabel>
                <Select
                  labelId="hours-travel-time-label"
                  id="hours-travel-time"
                  name="travelTime"
                  label="Travel Time"
                  onChange={handleTravelTime}
                  value={travelTime}
                >
                  <MenuItem value={"0.00"}>00:00</MenuItem>
                  <MenuItem value={"0.25"}>00:15</MenuItem>
                  <MenuItem value={"0.50"}>00:30</MenuItem>
                  <MenuItem value={"0.75"}>00:45</MenuItem>
                  <MenuItem value={"1.00"}>01:00</MenuItem>
                  <MenuItem value={"1.25"}>01:15</MenuItem>
                  <MenuItem value={"1.50"}>01:30</MenuItem>
                  <MenuItem value={"1.75"}>01:45</MenuItem>
                  <MenuItem value={"2.00"}>02:00</MenuItem>
                  <MenuItem value={"2.25"}>02:15</MenuItem>
                  <MenuItem value={"2.50"}>02:30</MenuItem>
                  <MenuItem value={"2.75"}>02:45</MenuItem>
                  <MenuItem value={"3.00"}>03:00</MenuItem>
                  <MenuItem value={"3.25"}>03:15</MenuItem>
                  <MenuItem value={"3.50"}>03:30</MenuItem>
                  <MenuItem value={"3.75"}>03:45</MenuItem>
                  <MenuItem value={"4.00"}>04:00</MenuItem>
                  <MenuItem value={"4.25"}>04:15</MenuItem>
                  <MenuItem value={"4.50"}>04:30</MenuItem>
                  <MenuItem value={"4.75"}>04:45</MenuItem>
                  <MenuItem value={"5.00"}>05:00</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={4} xs={6}>
              <TextField
                id="hours-start-time"
                name="startTime"
                label="Start Time"
                variant="outlined"
                type="time"
                className={
                  highlight
                    ? clsx(classes.formControl, classes.highlight)
                    : classes.formControl
                }
                fullWidth={true}
                value={startTime}
                onChange={handleStartTimeOnChange}
                onBlur={handleStartTimeOnBlur}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 900, // 15 min
                }}
              />
            </Grid>
            <Grid item md={4} xs={6}>
              <TextField
                id="hours-end-time"
                name="endTime"
                label="End Time:"
                variant="outlined"
                value={endTime}
                className={
                  highlight
                    ? clsx(classes.formControl, classes.highlight)
                    : classes.formControl
                }
                onChange={handleEndTimeOnChange}
                onBlur={handleEndTimeOnBlur}
                type="time"
                fullWidth={true}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 900, // 15 min
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item md={"auto"} xs={9}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                fullWidth={true}
              >
                <ToggleButtonGroup
                  exclusive
                  size={"small"}
                  aria-label="jobType"
                  value={jobType}
                  onChange={handleJobTypeChange}
                >
                  <ToggleButton
                    value="Direct"
                    aria-label="Direct"
                    style={{ padding: 10 }}
                  >
                    Direct
                  </ToggleButton>
                  <ToggleButton
                    value="InDirect"
                    aria-label="InDirect"
                    style={{ padding: 10 }}
                  >
                    InDirect
                  </ToggleButton>
                </ToggleButtonGroup>
              </FormControl>
            </Grid>

            {(screenSize == "md" ||
              screenSize == "sm" ||
              screenSize == "xs") && (
              <Grid item md={"auto"} xs={3}>
                <FormControlLabel
                  className={classes.rnd}
                  control={
                    <Switch
                      checked={RnD}
                      onChange={handleRnD}
                      color="primary"
                      name="RND"
                    />
                  }
                  label="R&D"
                />
              </Grid>
            )}

            <Grid item md={"auto"} xs={9}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                fullWidth={true}
              >
                <ToggleButtonGroup
                  exclusive
                  size={"small"}
                  aria-label="jobCategory"
                  value={jobCategory}
                  onChange={handleJobCategoryChange}
                >
                  <ToggleButton
                    value="Service"
                    aria-label="Service"
                    style={{ padding: 10 }}
                  >
                    Service
                  </ToggleButton>
                  <ToggleButton
                    value="Admin"
                    aria-label="Admin"
                    style={{ padding: 10 }}
                  >
                    Admin
                  </ToggleButton>
                  <ToggleButton
                    value="NonProd"
                    aria-label="NonProd"
                    style={{ padding: 10 }}
                  >
                    NonProd
                  </ToggleButton>
                </ToggleButtonGroup>
              </FormControl>
            </Grid>

            {(screenSize == "lg" || screenSize == "xl") && (
              <Grid item md={"auto"} xs={3}>
                <FormControlLabel
                  className={classes.rnd}
                  control={
                    <Switch
                      checked={RnD}
                      onChange={handleRnD}
                      color="primary"
                      name="RND"
                    />
                  }
                  label="R&D"
                />
              </Grid>
            )}

            <Grid item md={"auto"} xs={3} style={{ flexGrow: 1 }}>
              <Grid
                container
                justifyContent="flex-end"
                className={classes.formControl}
              >
                <Typography variant="overline" align="left">
                  Qty:
                </Typography>
                <Typography variant="overline" align="left">
                  <b>{hourDuration}</b>
                </Typography>
              </Grid>
            </Grid>

            <Grid item md={12} xs={12}>
              <TextField
                id="hours-platform"
                name="platform"
                label="Platform"
                variant="outlined"
                onChange={handlePlatform}
                className={
                  highlight
                    ? clsx(classes.formControl, classes.highlight)
                    : classes.formControl
                }
                fullWidth={true}
                value={platform}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl
                variant="outlined"
                className={
                  highlight
                    ? clsx(classes.formControl, classes.highlight)
                    : classes.formControl
                }
                fullWidth={true}
              >
                <TextField
                  required
                  id="hours-description"
                  name="description"
                  label="Description"
                  multiline
                  rows={4}
                  value={description}
                  onChange={handleDescriptionChange}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>

        <Divider />

        <CardActions className={classes.formAction}>
          <Button
            variant="contained"
            color="secondary"
            size="medium"
            className={classes.button}
            onClick={handleSave}
            startIcon={<SaveIcon />}
          >
            Save
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            className={classes.button}
            onClick={handleCancel}
            startIcon={<CancelIcon />}
          >
            Cancel
          </Button>
        </CardActions>
      </Card>
    </form>
  );
};

export default ManageHours;
